import {Div, ImageView, Label} from 'components';
import {Ecolors, Icons} from 'constant';
import React from 'react';
import {useAppSelector} from 'store/hooks';
import {parseMultilanguage} from 'utils';

function CardProfile(Props: {}) {
  const currentUser = useAppSelector(state => state.authen.currentUser);
  const {name, investmentProfile} = currentUser;
  const I18nState = useAppSelector(state => state.languages.I18nState);

  const convertCodeProfile = () => {
    var contentProfileStatus = '';

    if (!investmentProfile?.status) {
      contentProfileStatus = `component.chuaxacthuc`;
    } else {
      contentProfileStatus = `component.${investmentProfile?.status?.code}`;
    }
    return parseMultilanguage(contentProfileStatus);
  };

  return (
    <>
      <Div
        flexDirection={'row'}
        alignItems={'flex-start'}
        justifyContent={'flex-start'}
        padding={16}
        backgroundColor={Ecolors.whiteColor}>
        <Div
          widthHeight={40}
          borderRadius={40}
          alignItems={'center'}
          justifyContent={'center'}
          backgroundColor={Ecolors.grayColor}>
          <ImageView
            width={19}
            height={24}
            resizeMode={'contain'}
            source={Icons.profile}
            tintColor={Ecolors.textColor}
          />
        </Div>
        <Div
          paddingHorizontal={10}
          flexDirection={'column'}
          alignItems={'flex-start'}
          justifyContent={'flex-start'}>
          <Div paddingRight={30}>
            <Label multilanguage={false} numberOfLines={1} fontWeight={'500'}>
              {name?.toLocaleUpperCase() || ''}
            </Label>
          </Div>
          <Div
            flexDirection={'row'}
            alignItems={'center'}
            justifyContent={'flex-start'}>
            <Label
              size={13}
              color={Ecolors.grayColor}>{`profile.sotaikhoan`}</Label>
            <Label size={13} multilanguage={false} color={Ecolors.grayColor}>
              {investmentProfile?.number || ''}
            </Label>
          </Div>
          <Div
            paddingVertical={5}
            paddingHorizontal={10}
            marginTop={7}
            borderRadius={50}
            backgroundColor={
              investmentProfile?.status?.code == 'INVESTMENT_PROFILE_APPROVE' ||
              investmentProfile?.status?.code == 'INVESTMENT_PROFILE_ACCEPT'
                ? 'rgba(22, 199, 154, 0.2)'
                : 'rgba(255, 0, 0, 0.2)'
            }>
            <Label
              size={13}
              multilanguage={false}
              color={
                investmentProfile?.status?.code ==
                  'INVESTMENT_PROFILE_APPROVE' ||
                investmentProfile?.status?.code == 'INVESTMENT_PROFILE_ACCEPT'
                  ? Ecolors.greenColor
                  : Ecolors.redColor
              }>
              {convertCodeProfile()}
            </Label>
          </Div>
        </Div>
      </Div>
      <Div height={7} backgroundColor={Ecolors.bgtime} />
    </>
  );
}

export default React.memo(CardProfile);
